// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from '@/components/auth/AuthProvider'
import { ChatStreamProvider } from '@/app/context/ChatStreamContext'
import AppRoutes from './routes'
import NetSuiteCallback from './routes/settings/NetSuiteCallback'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* OAuth コールバックは認証不要（ポップアップで code/state を親に postMessage するだけ） */}
        <Route path="/settings/netsuite/callback" element={<NetSuiteCallback />} />
        <Route path="/*" element={
          <AuthProvider>
            {/* Chat ストリーミングは Provider 上で保持。/chat → /admin など他ルートに遷移しても
                Provider はアンマウントされないため SSE が継続し、完了時に DB へ自動保存。 */}
            <ChatStreamProvider>
              <AppRoutes />
            </ChatStreamProvider>
          </AuthProvider>
        } />
      </Routes>
    </BrowserRouter>
  )
}
